import { render, staticRenderFns } from "./course_account_transfer.vue?vue&type=template&id=15d104fa&scoped=true"
import script from "./course_account_transfer.vue?vue&type=script&lang=js"
export * from "./course_account_transfer.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/course-account-dialog.scss?vue&type=style&index=0&id=15d104fa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d104fa",
  null
  
)

export default component.exports